import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "SearchReceipt",
    redirect: "receipt",
    component: () => import("../views/SearchReceiptV2.vue"),
    children:[{
      path: "/receipt",
      name: "SearchReceiptForm",
      component: () => import("../components/SearchReceiptForm.vue"),
    },{
      path: "results",
      name: "ReceiptDetails",
      component: () => import("../components/ReceiptDetails.vue"),
    },
    {
      path: "adv-search",
      name: "AdvSearch",
      component: () => import("../components/AdvSearchForm.vue"),
    }, {
      path: "receipt-not-found",
      name: "ReceiptNotFound",
      component: () => import("../components/ReceiptNotFound.vue"),
    }]
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});
export default router;
